import { Colors } from '@sigma-frontend-libs/commons'

import { sizes } from '@/utils'

import { baseClass } from '@/components/rules/utils'
import tag from '@/components/tag'

function renderItem(h, item) {
  const label = this.getLabel(item)
  if (!label) {
    return null
  }

  return h(
    tag,
    {
      props: {
        label,
        color: Colors.primary,
        size: sizes.small
      }
    }
  )
}

function renderItems(h) {
  return this.visibleItems.map(item => {
    return renderItem.call(this, h, item)
  })
}

function renderOverflowTag(h) {
  if (!this.shouldShowOverflow) {
    return null
  }

  return h(
    tag,
    {
      props: {
        label: `+${this.overflowCount}`,
        color: Colors.black,
        size: sizes.small
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${baseClass}-item__holder-value`
    },
    [
      renderItems.call(this, h),
      renderOverflowTag.call(this, h)
    ]
  )
}
